import { type FC, type SVGProps } from 'react';

const DesignSystemIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7 12C7 9.23858 9.23858 7 12 7V12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z" />
  </svg>
);

export default DesignSystemIcon;
